import type { Role } from '@mct/shared';

export type InvitationFormError =
  | 'email-empty'
  | 'email-invalid'
  | 'role-invalid';

export interface InvitationFormResult {
  ok: boolean;
  email: string;
  role: Role;
  errors: InvitationFormError[];
}

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const VALID_ROLES: readonly Role[] = ['owner', 'admin', 'editor', 'viewer'];

export function validateInvitationForm(
  rawEmail: string,
  rawRole: string,
): InvitationFormResult {
  const errors: InvitationFormError[] = [];
  const email = rawEmail.trim().toLowerCase();

  if (email.length === 0) errors.push('email-empty');
  else if (!EMAIL_RE.test(email)) errors.push('email-invalid');

  const roleOk = (VALID_ROLES as readonly string[]).includes(rawRole);
  if (!roleOk) errors.push('role-invalid');

  return {
    ok: errors.length === 0,
    email,
    role: (roleOk ? rawRole : 'viewer') as Role,
    errors,
  };
}
